import { Component } from 'react';

interface Props {
  readonly children: React.ReactNode;
}

interface IState {
  hasError: boolean;
}

export default class ErrorBoundary extends Component<Props, IState> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }
  /**
   * @param error
   */
  public static getDerivedStateFromError(error: unknown) {
    return { hasError: true };
  }

  /**
   *
   */
  public render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
